{
  "COMPOSE_REDIRECT": {
    "OPENING": "Apertura di una nuova conversazione con {email}…",
    "NO_EMAIL": "Nessun indirizzo email fornito. Usa ?email=name@example.com",
    "CONTACT_ERROR": "Impossibile trovare il contatto per {email}."
  },
  "CONVERSATION": {
    "404": "Siamo spiacenti, non siamo riusciti a trovare la conversazione. Riprova",
    "IMAGE_RESIZE": {
      "SMALL": "Piccola",
      "MEDIUM": "Media",
      "LARGE": "Grande",
      "ORIGINAL": "Originale"
    },
    "SHOW_HIDDEN_MESSAGES": "Mostra messaggi nascosti",
    "SELECT_A_CONVERSATION": "Si prega di selezionare una conversazione dal pannello sinistro",
    "CSAT_REPLY_MESSAGE": "Valuta la conversazione",
    "SWITCH_VIEW_LAYOUT": "Cambia il layout",
    "DASHBOARD_APP_TAB_MESSAGES": "Messaggi",
    "UNVERIFIED_SESSION": "L'identità di questo utente non è verificata",
    "NO_MESSAGE_1": "Oh oh! Sembra che non ci siano messaggi da parte dei clienti nella tua casella.",
    "NO_MESSAGE_2": " per inviare un messaggio alla tua pagina!",
    "NO_INBOX_1": "Hola! Sembra che tu non abbia ancora aggiunto nessuna casella.",
    "NO_INBOX_2": " per iniziare",
    "NO_INBOX_AGENT": "Uh Oh! Sembra che tu non faccia parte di nessuna casella. Per favore contatta il tuo amministratore",
    "SEARCH_MESSAGES": "Cerca messaggi nelle conversazioni",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Traduzione",
    "EMPTY_STATE": {
      "CMD_BAR": "to open command menu",
      "KEYBOARD_SHORTCUTS": "to view keyboard shortcuts"
    },
    "SEARCH": {
      "TITLE": "Cerca messaggi",
      "RESULT_TITLE": "Risultati della ricerca",
      "LOADING_MESSAGE": "Elaborazione dei dati...",
      "PLACEHOLDER": "Digita qualsiasi testo per cercare i messaggi",
      "NO_MATCHING_RESULTS": "Nessun risultato trovato."
    },
    "TRANSCRIPT": {
      "SHOW": "Mostra trascrizione completa",
      "HIDE": "Nascondi trascrizione completa",
      "DOWNLOAD": "Scarica trascrizione",
      "COPY": "Copia trascrizione"
    },
    "INVISIBLE_TO_CUSTOMER": "Invisibile al cliente",
    "SENT_VIA_EMAIL": "Inviato al contatto anche via email ({time})",
    "UNREAD_MESSAGES": "Messaggi non letti",
    "UNREAD_MESSAGE": "Messaggio non letto",
    "CLICK_HERE": "Clicca qui",
    "LOADING_INBOXES": "Caricamento casella",
    "LOADING_CONVERSATIONS": "Caricamento conversazioni",
    "CANNOT_REPLY": "Non puoi rispondere a causa di",
    "24_HOURS_WINDOW": "Restrizione della finestra del messaggio a 24 ore",
    "API_HOURS_WINDOW": "Puoi rispondere a questa conversazione solo entro {hours} ore",
    "FACEBOOK_CANNOT_REPLY": "Se hai bisogno di continuare questa conversazione, ",
    "NOT_ASSIGNED_TO_YOU": "Questa conversazione non è assegnata. Vuoi assegnare questa conversazione a te stesso?",
    "ASSIGN_TO_ME": "Assegna a me",
    "PENDING_WITH_BOT_BANNER": "Questa conversazione è gestita dal bot AI. Se vuoi rispondere, apri prima la conversazione.",
    "INBOX_DELETE_REQUESTED_BANNER": "Questa casella è contrassegnata per l'eliminazione, quindi la risposta del cliente non arriverebbe mai. Sposta la conversazione in un'altra casella per rispondere.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Questo contatto ha un'altra conversazione aperta #{id}",
      "MULTIPLE": "Questo contatto ha altre conversazioni aperte ({count})",
      "OPEN": "Apri",
      "SHOW": "Mostra"
    },
    "TWILIO_WHATSAPP_CAN_REPLY": "È possibile rispondere a questa conversazione solo utilizzando un messaggio modello a causa di",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "Restrizione della finestra del messaggio a 24 ore",
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "Questo account Instagram è stato migrato alla nuova casella del canale Instagram. Tutti i nuovi messaggi compariranno lì. Non potrai più inviare messaggi da questa conversazione.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Impossibile inviare il messaggio perché il cliente non è online e la continuità email non è disponibile.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "Il cliente non è online. Potrebbe non ricevere i messaggi poiché la continuità email non è disponibile.",
    "REPLYING_TO": "Stai rispondendo a:",
    "REMOVE_SELECTION": "Rimuovi selezione",
    "DOWNLOAD": "Scarica",
    "OPEN_FILE": "Apri",
    "DOWNLOAD_ATTACHMENTS": "Scarica tutti",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Scarica tutti gli allegati uno per uno",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Scarica tutti come ZIP",
    "ERROR_DOWNLOADING_FILE": "Errore durante il download del file",
    "UNKNOWN_FILE_TYPE": "File sconosciuto",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Prima di inviare, esegui:",
      "EXECUTE": "Esegui",
      "RETRY": "Riprova",
      "CONFIRM": "Eseguire ora?",
      "CONFIRM_YES": "Sì, esegui",
      "CONFIRM_NO": "Annulla",
      "RUNNING": "In esecuzione…",
      "DONE": "Fatto",
      "CLAIM_DELAYED": "verrà aperto alla consegna dell'ordine",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "Aperto un NUOVO reclamo {reference}, {planned} è chiuso — modifica il testo della bozza",
        "NEW_CLAIM": "Aperto un NUOVO reclamo {reference} invece di aggiornare {planned} — modifica il testo della bozza",
        "OTHER_CLAIM": "Aggiornato il reclamo {reference} invece di {planned} — modifica il testo della bozza",
        "EXISTING_CLAIM": "Nessun nuovo reclamo aperto, aggiornato quello esistente {reference} — modifica il testo della bozza",
        "OTHER": "È andata diversamente da quanto previsto dalla bozza — modifica il testo della bozza"
      },
      "FAILED": "Non riuscito",
      "UNREACHABLE": "Il bot non è raggiungibile",
      "REQUEST_FAILED": "Impossibile avviare l'azione, riprova.",
      "ACTIONS": {
        "CANCEL_ORDER": "Annulla l'ordine",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Cambia il pagamento in contrassegno",
        "CREATE_CLAIM": "Apri un reclamo",
        "CREATE_OR_UPDATE_CLAIM": "Apri o aggiorna un reclamo",
        "EXTEND_ORDER_PICKUP_DATE": "Proroga il termine di ritiro"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file"
    },
    "UPLOADING_ATTACHMENTS": "Caricamento allegati...",
    "REPLIED_TO_STORY": "Replied to your story",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "This message is unsupported. You can view this message on the Facebook Messenger app.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "This message is unsupported. You can view this message on the Instagram app.",
    "SUCCESS_DELETE_MESSAGE": "Messaggio eliminato con successo",
    "FAIL_DELETE_MESSSAGE": "Impossibile eliminare il messaggio! Riprova",
    "NO_RESPONSE": "Nessuna risposta",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Chiedi al cliente di condividere il suo numero di telefono WhatsApp",
      "PENDING_ACTION": "Richiesta di informazioni di contatto in attesa",
      "STATES": {
        "PENDING": "In attesa delle informazioni di contatto",
        "SHARED": "Numero di telefono condiviso",
        "IDENTITY_CONFLICT": "Numero di telefono da verificare"
      }
    },
    "RESPONSE": "Response",
    "RATING_TITLE": "Valutazione",
    "FEEDBACK_TITLE": "Feedback",
    "REPLY_MESSAGE_NOT_FOUND": "Message not available",
    "CARD": {
      "SHOW_LABELS": "Show labels",
      "HIDE_LABELS": "Hide labels"
    },
    "HEADER": {
      "MORE": "Altre azioni",
      "RESOLVE_ACTION": "Risolvi",
      "REOPEN_ACTION": "Riapri",
      "OPEN_ACTION": "Apri",
      "OPEN": "Altro",
      "CLOSE": "Chiudi",
      "DETAILS": "Dettagli",
      "SNOOZED_UNTIL": "Snoozed until",
      "SNOOZED_UNTIL_TOMORROW": "Posticipato fino a domani",
      "SNOOZED_UNTIL_NEXT_WEEK": "Posticipato fino alla prossima settimana",
      "SNOOZED_UNTIL_NEXT_REPLY": "Posticipato fino alla prossima risposta",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      }
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Segna come in sospeso",
      "SNOOZE_UNTIL": "Posticipa",
      "RESOLVE_WITHOUT_CSAT": "Risolvi senza CSAT",
      "SNOOZE": {
        "TITLE": "Posticipa fino a",
        "NEXT_REPLY": "Risposta successiva",
        "TOMORROW": "Domani",
        "NEXT_WEEK": "Prossima settimana"
      }
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Posticipa fino a",
      "APPLY": "Posticipa",
      "CANCEL": "annulla"
    },
    "PRIORITY": {
      "TITLE": "Priorità",
      "OPTIONS": {
        "NONE": "Nessuno",
        "URGENT": "Urgente",
        "HIGH": "Alta",
        "MEDIUM": "Media",
        "LOW": "Bassa"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Nessuno",
        "INPUT_PLACEHOLDER": "Select priority",
        "NO_RESULTS": "Nessun risultato trovato",
        "SUCCESSFUL": "Changed priority of conversation id {conversationId} to {priority}",
        "FAILED": "Couldn't change priority. Please try again."
      }
    },
    "SLA": {
      "BREACHED": "violato"
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Apri in una nuova scheda",
      "COPY_LINK": "Copia il link della conversazione",
      "COPY_LINK_SUCCESS": "Link della conversazione copiato negli appunti",
      "PENDING": "Segna come in sospeso",
      "RESOLVED": "Contrassegna come risolto",
      "MARK_AS_UNREAD": "Mark as unread",
      "MARK_AS_READ": "Segna come letto",
      "REOPEN": "Riapri la conversazione",
      "SNOOZE": {
        "TITLE": "Posticipa",
        "NEXT_REPLY": "Fino alla prossima risposta",
        "TOMORROW": "Fino a domani",
        "NEXT_WEEK": "Fino alla prossima settimana"
      },
      "ASSIGN_AGENT": "Assegna agente",
      "ASSIGN_LABEL": "Assegna etichetta",
      "AGENTS_LOADING": "Caricamento agenti...",
      "ASSIGN_TEAM": "Assegna team",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "ID conversazione {conversationId} assegnato a \"{agentName}\"",
          "FAILED": "Impossibile assegnare l'agente. Per favore riprova."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Impossibile assegnare l'etichetta. Per favore riprova."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Assegnato il team \"{team}\" all'id conversazione {conversationId}",
          "FAILED": "Impossibile assegnare il team. Riprova."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Firma del messaggio",
      "ENABLE_SIGN_TOOLTIP": "Abilita firma",
      "DISABLE_SIGN_TOOLTIP": "Disabilita firma",
      "INSERT_SIGNATURE": "Inserisci firma nell'editor",
      "SIGNATURE_PREVIEW_IMAGE": "(firma con immagine)",
      "MSG_INPUT": "MAIUSC + INVIO per la nuova linea. Inizia con '/' per selezionare una risposta predefinita.",
      "PRIVATE_MSG_INPUT": "MAIUSC + INVIO per nuova linea. Questo sarà visibile solo agli agenti",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "La firma del messaggio non è configurata, configurala nelle impostazioni del profilo.",
      "CLICK_HERE": "Clicca qui per aggiornare",
      "WHATSAPP_TEMPLATES": "Modelli Whatsapp",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "La finestra di 24 ore di WhatsApp è scaduta. Rispondi con un modello."
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "La tua risposta sembra essere in {draftLanguage}, ma questa conversazione è in {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Traduci",
      "REPLY": "Rispondi",
      "PRIVATE_NOTE": "Nota privata",
      "SEND": "Invia",
      "SEND_EMAIL": "Invia email",
      "SEND_SMS": "Invia SMS",
      "NO_SMS_INBOX": "Aggiungi una casella SMS per inviare risposte via SMS.",
      "SEND_CHAT": "Invia chat",
      "CREATE": "Aggiungi nota",
      "INSERT_READ_MORE": "Read more",
      "DISMISS_REPLY": "Dismiss reply",
      "REPLYING_TO": "Replying to:",
      "REPLY_TO_THIS": "Rispondi a questo",
      "TIP_EXPAND_ICON": "Ingrandisci editor",
      "TIP_COLLAPSE_ICON": "Riduci editor",
      "TIP_FORMAT_ICON": "Mostra editor di testo ricco",
      "HEADING_LEVEL": {
        "LABEL": "Stile del testo",
        "NORMAL": "Testo normale",
        "H1": "Titolo 1",
        "H2": "Titolo 2",
        "H3": "Titolo 3"
      },
      "EDITOR": {
        "BOLD": "Grassetto",
        "ITALIC": "Corsivo",
        "UNDERLINE": "Sottolineato",
        "TEXT_COLOR": "Colore testo",
        "BG_COLOR_LABEL": "Colore sfondo",
        "FONT_SIZE_LABEL": "Dimensione carattere",
        "FONT_SIZE": {
          "XS": "Piccolo",
          "SM": "Medio piccolo",
          "MD": "Predefinito",
          "LG": "Grande",
          "XL": "Molto grande",
          "XXL": "Enorme"
        },
        "CODE": "Codice",
        "LINK": "Aggiungi o rimuovi link",
        "CREATE_LINK": "Crea link",
        "SAVE_LINK": "Salva",
        "CANCEL": "Annulla",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Annulla",
        "REDO": "Ripristina",
        "BULLET_LIST": "Elenco puntato",
        "ORDERED_LIST": "Elenco numerato",
        "BLOCKQUOTE": "Citazione",
        "H1": "Titolo 1",
        "H2": "Titolo 2",
        "H3": "Titolo 3",
        "IMAGE_UPLOAD": "Carica immagine",
        "CLEAR_FORMATTING": "Cancella formattazione",
        "COLOR": {
          "RED": "Rosso",
          "YELLOW": "Giallo",
          "BLUE": "Blu",
          "ROSE_RED": "Rosso rosa",
          "DEEP_CYAN": "Ciano scuro",
          "ORANGE": "Arancione",
          "PISTACHIO": "Pistacchio",
          "PURPLE": "Viola",
          "FUCHSIA": "Fucsia",
          "SILVER": "Argento",
          "NAVY": "Blu navy",
          "OLD_PINK": "Rosa antico",
          "AQUA": "Acqua",
          "BROWN": "Marrone",
          "OLIVE": "Oliva",
          "GOLD": "Oro",
          "BEIGE": "Beige",
          "WINE": "Bordeaux",
          "FOREST": "Verde bosco",
          "GREEN": "Verde",
          "BLUE_GREY": "Grigio blu",
          "RUBY_RED": "Rosso rubino",
          "CHESTNUT_BROWN": "Marrone castagna",
          "ASH_GREY": "Grigio cenere"
        },
        "BG_COLOR": {
          "RED": "Rosso",
          "YELLOW": "Giallo",
          "BLUE": "Blu",
          "ROSE_RED": "Rosso rosa",
          "DEEP_CYAN": "Ciano scuro",
          "ORANGE": "Arancione",
          "PISTACHIO": "Pistacchio",
          "PURPLE": "Viola",
          "FUCHSIA": "Fucsia",
          "SILVER": "Argento",
          "NAVY": "Blu navy",
          "OLD_PINK": "Rosa antico",
          "AQUA": "Acqua",
          "BROWN": "Marrone",
          "OLIVE": "Oliva",
          "GOLD": "Oro",
          "BEIGE": "Beige",
          "WINE": "Bordeaux",
          "FOREST": "Verde bosco",
          "GREEN": "Verde",
          "BLUE_GREY": "Grigio blu",
          "RUBY_RED": "Rosso rubino",
          "CHESTNUT_BROWN": "Marrone castagna",
          "ASH_GREY": "Grigio cenere"
        }
      },
      "TIP_EMOJI_ICON": "Mostra selettore emoji",
      "TIP_ATTACH_ICON": "Allega file",
      "TIP_AUDIORECORDER_ICON": "Registra audio",
      "TIP_AUDIORECORDER_PERMISSION": "Consenti l'accesso all'audio",
      "TIP_AUDIORECORDER_ERROR": "Impossibile aprire l'audio",
      "DRAG_DROP": "Trascina qui per allegare",
      "START_AUDIO_RECORDING": "Avvia registrazione audio",
      "STOP_AUDIO_RECORDING": "Interrompi registrazione audio",
      "EMAIL_HEAD": {
        "EDIT": "Modifica",
        "EXPAND": "Cc/Ccn",
        "HIDE": "Nascondi",
        "INCLUDE_ORIGINAL_MESSAGE": "Includi messaggio originale",
        "TO": "TO",
        "ADD_BCC": "Aggiungi bcc",
        "EDIT_HEADERS": "Modifica",
        "HIDE_HEADER_EDITS": "Nascondi modifiche",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "Email separate da virgole",
          "ERROR": "Inserisci indirizzi email validi"
        },
        "BCC": {
          "LABEL": "CCN",
          "PLACEHOLDER": "Email separate da virgole",
          "ERROR": "Inserisci indirizzi email validi"
        },
        "SUBJECT": {
          "LABEL": "OGGETTO",
          "PLACEHOLDER": "Oggetto email",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Undefined variables",
        "MESSAGE": "You have {undefinedVariablesCount} undefined variables in your message: {undefinedVariables}. Would you like to send the message anyway?",
        "CONFIRM": {
          "YES": "Invia",
          "CANCEL": "annulla"
        }
      },
      "COPILOT": {
        "Q": "Chiedi aiuto al robot"
      }
    },
    "VISIBLE_TO_AGENTS": "Nota privata: visibile solo a te e al tuo team",
    "CHANGE_STATUS": "Stato conversazione cambiato",
    "CHANGE_STATUS_FAILED": "Cambio di stato conversazione non riuscito",
    "CHANGE_AGENT": "Modifica assegnatario conversazione",
    "CHANGE_AGENT_FAILED": "Cambio assegnatario non riuscito",
    "ASSIGN_LABEL_SUCCESFUL": "Etichetta assegnata correttamente",
    "ASSIGN_LABEL_FAILED": "Assegnazione etichetta non riuscita",
    "CHANGE_TEAM": "Team conversazione cambiato",
    "IMAGE_UPLOAD_ERROR": "Impossibile caricare l'immagine, riprova",
    "FILE_SIZE_LIMIT": "Il file supera il limite di {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB per l'allegato",
    "DRAFT": {
      "FILE_TOO_LARGE": "Il file '{fileName}' ({fileSize}) è troppo grande per essere salvato come bozza e sarà ignorato",
      "ATTACHMENT_SERIALIZATION_FAILED": "Impossibile serializzare l'allegato per il salvataggio della bozza",
      "STORAGE_QUOTA_EXCEEDED": "Quota di archiviazione superata. Bozza salvata senza allegati",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Impossibile salvare la bozza anche senza allegati",
      "SAVE_FAILED": "Impossibile salvare la bozza della conversazione"
    },
    "MESSAGE_ERROR": "Impossibile inviare questo messaggio, riprova più tardi",
    "SENT_BY": "Inviato da:",
    "BOT": "Bot",
    "SEND_FAILED": "Impossibile inviare il messaggio! Riprova",
    "TRY_AGAIN": "riprova",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Seleziona agente",
      "REMOVE": "Rimuovi",
      "ASSIGN": "Assegna"
    },
    "CONTEXT_MENU": {
      "COPY": "Copia",
      "REPLY_TO": "Reply to this message",
      "DELETE": "Elimina",
      "CREATE_A_CANNED_RESPONSE": "Add to canned responses",
      "TRANSLATE": "Translate",
      "COPY_PERMALINK": "Copy link to the message",
      "LINK_COPIED": "Message URL copied to the clipboard",
      "FORWARD": "Inoltra",
      "FORWARD_ERROR": "Impossibile preparare il messaggio da inoltrare",
      "DELETE_CONFIRMATION": {
        "TITLE": "Are you sure you want to delete this message?",
        "MESSAGE": "You cannot undo this action",
        "DELETE": "Elimina",
        "CANCEL": "Annulla"
      }
    },
    "SIDEBAR": {
      "CONTACT": "Contatto",
      "COPILOT": "Copilot"
    },
    "COMMENT_TREE": {
      "TITLE": "Thread dei commenti",
      "EMPTY": "Nessun commento da mostrare",
      "VIEW_TREE": "Visualizza thread dei commenti"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "La conversazione è stata contrassegnata come risolta da {userName}",
          "CONTACT_RESOLVED": "La conversazione è stata risolta da {contactName}",
          "OPEN": "La conversazione è stata riaperta da {userName}",
          "PENDING": "La conversazione è stata contrassegnata come in attesa da {userName}",
          "SNOOZED": "La conversazione è stata posticipata da {userName}",
          "AUTO_RESOLVED": "La conversazione è stata contrassegnata come risolta dal sistema a causa di {duration} giorni d'inattività",
          "SYSTEM_AUTO_OPEN": "Il sistema ha riaperto la conversazione a causa di un nuovo messaggio in arrivo.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "La conversazione è stata contrassegnata come risolta da {userName} (senza CSAT)",
          "AUTO_RESOLVED_INACTIVE": "La conversazione è stata contrassegnata come risolta dal sistema a causa di {duration} ore di inattività",
          "AUTO_RESOLVED_EMPTY": "La conversazione è stata contrassegnata come risolta dal sistema perché vuota.",
          "BLOCKED_CONTACT_RESOLVED": "Il sistema ha risolto la conversazione perché il contatto è bloccato.",
          "KAUFLAND_TICKET_CLOSED": "Il sistema ha risolto la conversazione perché il ticket è stato chiuso su Kaufland."
        },
        "PRIORITY": {
          "ADDED": "{userName} ha impostato la priorità a {newPriority}",
          "UPDATED": "{userName} ha cambiato la priorità da {oldPriority} a {newPriority}",
          "REMOVED": "{userName} ha rimosso la priorità"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} si è assegnato a questa conversazione",
          "ASSIGNED": "Assegnato a {assigneeName} da {userName}",
          "REMOVED": "Conversazione non assegnata da {userName}"
        },
        "TEAM": {
          "ASSIGNED": "Assegnato a {teamName} da {userName}",
          "ASSIGNED_WITH_ASSIGNEE": "Assegnato a {assigneeName} tramite {teamName} da {userName}",
          "REMOVED": "Assegnazione a {teamName} rimossa da {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} ha aggiunto {labels}",
          "REMOVED": "{userName} ha rimosso {labels}"
        },
        "SLA": {
          "ADDED": "{userName} ha aggiunto la policy SLA {slaName}",
          "REMOVED": "{userName} ha rimosso la policy SLA {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} ha silenziato la conversazione",
        "UNMUTED": "{userName} ha riattivato l'audio della conversazione",
        "CONTACT_BLOCKED": "{userName} ha bloccato il contatto",
        "CONTACT_UNBLOCKED": "{userName} ha sbloccato il contatto",
        "AUTO_RESOLUTION_MESSAGE": "La conversazione viene risolta poiché è inattiva da un po' di tempo. Avvia una nuova conversazione se hai bisogno di ulteriore assistenza.",
        "DOMAIN_BLOCKED": "{userName} ha bloccato tutti i contatti per un dominio specifico",
        "DOMAIN_UNBLOCKED": "{userName} ha sbloccato tutti i contatti per un dominio specifico",
        "MERGED": "{userName} ha unito la conversazione #{sourceId} in questa conversazione",
        "MOVED": "{userName} ha spostato questa conversazione dalla casella {sourceInboxName} alla casella {targetInboxName}",
        "MOVED_BY_ORDER": "Spostata perché gli ordini del contatto provengono solo dal negozio {storeName} (ultimo ordine {orderId}), il cui robot risponde in questa casella.",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "L'azione di invio messaggio è stata saltata per questo messaggio di risposta automatica",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "L'automazione è stata saltata perché il contatto è bloccato",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "L'automazione \"{ruleName}\" non è riuscita a spostare questa conversazione dalla casella {sourceInboxName} alla casella {targetInboxName} perché le caselle non sono compatibili.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "L'automazione \"{ruleName}\" non è riuscita a spostare questa conversazione dalla casella {sourceInboxName} alla casella {targetInboxName} perché il contatto non ha un indirizzo email.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "L'automazione \"{ruleName}\" non ha potuto inviare un messaggio: questa casella telefonica non può inviare SMS perché l'account non ha alcuna casella SMS. La regola è stata disattivata e gli amministratori hanno ricevuto un'email.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "L'automazione \"{ruleName}\" non ha potuto inviare un messaggio: gli allegati non possono essere inviati via SMS da questa casella. La regola è stata disattivata e gli amministratori hanno ricevuto un'email.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "La macro \"{macroName}\" non ha inviato il suo messaggio: questa casella telefonica non può inviare SMS perché l'account non ha alcuna casella SMS.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "La macro \"{macroName}\" non ha inviato il suo messaggio: gli allegati non possono essere inviati via SMS da questa casella.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "La macro \"{macroName}\" non ha inviato il suo messaggio: il bot sta gestendo questa conversazione. Apri prima la conversazione.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "La macro \"{macroName}\" non ha inviato il suo messaggio: questa casella è contrassegnata per l'eliminazione. Sposta prima la conversazione in un'altra casella.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "L'automazione \"{ruleName}\" ha inviato un'email a {contactEmail} in una nuova conversazione [#{conversationId}]({conversationPath}) nella casella {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "L'automazione \"{ruleName}\" ha avviato questa conversazione a seguito della conversazione [#{conversationId}]({conversationPath}) nella casella {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "L'automazione \"{ruleName}\" non è riuscita a inviare il messaggio in una nuova conversazione nella casella {inboxName} perché il contatto non ha un indirizzo email.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "L'automazione \"{ruleName}\" ha inviato un SMS a {contactPhone} in una nuova conversazione [#{conversationId}]({conversationPath}) nella casella {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "L'automazione \"{ruleName}\" non è riuscita a inviare l'SMS in una nuova conversazione nella casella {inboxName} perché il contatto non ha un numero di telefono.",
        "AUTOMATION_RULE_TRIGGERED": "Regola di automazione \"{ruleName}\" attivata",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "La regola di automazione \"{ruleName}\" ha disabilitato la priorità automatica",
        "AUTOMATION_SKIP_AUTO_LABELING": "La regola di automazione \"{ruleName}\" ha disabilitato l'etichettatura automatica",
        "AUTOMATION_STOP_PROCESSING_RULES": "La regola di automazione \"{ruleName}\" ha interrotto ulteriori elaborazioni di regole",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Agente",
            "CUSTOMER": "Cliente"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "risposta altrove, squillato per {duration}",
            "NO_ANSWER": "senza risposta, squillato per {duration}",
            "REJECTED": "rifiutata dopo aver squillato per {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Risolta automaticamente dopo {count} richiamate senza risposta",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Registrazione della chiamata eliminata da {name}, {date}"
        }
      }
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Invia trascrizione conversazione",
    "DESC": "Invia una copia della trascrizione della conversazione all'indirizzo email specificato",
    "SUBMIT": "Invia",
    "CANCEL": "Annulla",
    "SEND_EMAIL_SUCCESS": "La trascrizione della chat è stata inviata con successo",
    "SEND_EMAIL_ERROR": "Si è verificato un errore, riprova",
    "FORM": {
      "SEND_TO_CONTACT": "Invia la trascrizione al cliente",
      "SEND_TO_AGENT": "Invia la trascrizione all'agente assegnato",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Invia la trascrizione a un altro indirizzo email",
      "EMAIL": {
        "PLACEHOLDER": "Inserisci un indirizzo email",
        "ERROR": "Inserisci un indirizzo email valido"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Ehi 👋, Benvenuto in {installationName}!",
    "DESCRIPTION": "Grazie per esserti registrato. Vogliamo che tu ottenga il massimo da {installationName}. Ecco alcune cose che puoi fare in {installationName} per rendere l'esperienza deliziosa.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Leggi gli ultimi aggiornamenti",
    "ALL_CONVERSATION": {
      "TITLE": "Tutte le conversazioni in un unico luogo",
      "DESCRIPTION": "Visualizza tutte le conversazioni dai tuoi clienti in una singola dashboard. È possibile filtrare le conversazioni in base al canale, all'etichetta e allo stato in arrivo.",
      "NEW_LINK": "Clicca qui per creare una casella di posta"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Invita i membri del tuo team",
      "DESCRIPTION": "Dal momento che siete sempre pronti a parlare con il vostro cliente, portare nei vostri compagni di squadra per assistervi. Puoi invitare i tuoi compagni di squadra aggiungendo i loro indirizzi email alla lista degli agenti.",
      "NEW_LINK": "Clicca qui per invitare un membro del team"
    },
    "LABELS": {
      "TITLE": "Organizza le conversazioni con etichette",
      "DESCRIPTION": "Le etichette forniscono un modo più semplice per categorizzare la conversazione. Crea alcune etichette come #support-enquiry, #billing-question ecc., in modo da poterle usare in una conversazione più tardi.",
      "NEW_LINK": "Clicca qui per creare etichette"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Agente assegnato",
    "SELF_ASSIGN": "Assegna a me",
    "TEAM_LABEL": "Team assegnato",
    "SELECT": {
      "PLACEHOLDER": "Nessuno"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Dati personalizzati",
      "ORDER_HISTORY": "Cronologia ordini",
      "CONTACT_DETAILS": "Dettagli contatto",
      "CONVERSATION_ACTIONS": "Azioni conversazione",
      "CONVERSATION_LABELS": "Etichette conversazione",
      "CONVERSATION_INFO": "Informazioni conversazione",
      "CONTACT_ATTRIBUTES": "Attributi contatti",
      "PREVIOUS_CONVERSATION": "Conversazioni precedenti",
      "MACROS": "Macros",
      "RETINO_TICKETS": "Ticket Retino",
      "SHOPIFY_ORDERS": "Shopify Orders"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "In sospeso",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "Nessun dato trovato",
    "LOAD_ERROR": "Impossibile caricare i dati. Riprova più tardi."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Carica altri",
    "NO_RECORDS_FOUND": "Nessun ticket trovato",
    "LOAD_ERROR": "Impossibile caricare i ticket da {hookName}. Riprova più tardi.",
    "NOT_SEARCHABLE": "L'email del contatto non è impostata.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Caricamento...",
    "NO_ORDERS": "Nessun ordine trovato",
    "NOT_AVAILABLE": "Dati cliente non disponibili",
    "EXPAND": "Apri profilo cliente",
    "MORE_ITEMS": "+ {count} articoli",
    "EXPEDITION_STATUS": "Stato spedizione",
    "OPEN_DETAIL": "apri dettaglio",
    "COPY_ORDER_ID": "Numero d'ordine",
    "EXTERNAL_ID": "ID esterno",
    "PAYMENT_TYPE": "Metodo di pagamento",
    "PAYMENT_DATE": "Data di pagamento",
    "DELIVERY_PROVIDER": "Corriere",
    "EXPECTED_DATE_OF_DELIVERY": "Consegna prevista",
    "DATE_OF_DELIVERY": "Consegnato il",
    "EXPEDITION_DATE": "Data di spedizione",
    "INTERNAL_NOTE": "Nota del negozio",
    "PACKAGE_NUMBER": "Spedizione"
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Crea attributo",
    "NO_RECORDS_FOUND": "Nessun attributo trovato",
    "UPDATE": {
      "SUCCESS": "Attributo aggiornato con successo",
      "ERROR": "Impossibile aggiornare l'attributo. Riprova più tardi"
    },
    "ADD": {
      "TITLE": "Aggiungi",
      "SUCCESS": "Attributo aggiunto con successo",
      "ERROR": "Impossibile aggiungere l'attributo. Riprova più tardi"
    },
    "DELETE": {
      "SUCCESS": "Attributo eliminato con successo",
      "ERROR": "Impossibile eliminare l'attributo. Riprova più tardi"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Aggiungi attributi",
      "PLACEHOLDER": "Cerca attributi",
      "NO_RESULT": "Nessun attributo trovato"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "Da",
    "TO": "A",
    "BCC": "CCN",
    "CC": "Cc",
    "SUBJECT": "Oggetto"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Participating",
    "SIDEBAR_TITLE": "Conversation participants",
    "NO_RECORDS_FOUND": "Nessun risultato trovato",
    "ADD_PARTICIPANTS": "Select participants",
    "REMANING_PARTICIPANTS_TEXT": "+{count} others",
    "REMANING_PARTICIPANT_TEXT": "+{count} other",
    "TOTAL_PARTICIPANTS_TEXT": "{count} people are participating.",
    "TOTAL_PARTICIPANT_TEXT": "{count} person is participating.",
    "NO_PARTICIPANTS_TEXT": "No one is participating!.",
    "WATCH_CONVERSATION": "Join conversation",
    "YOU_ARE_WATCHING": "You are participating",
    "API": {
      "ERROR_MESSAGE": "Could not update, try again!",
      "SUCCESS_MESSAGE": "Participants updated!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "View translated content",
    "DESC": "You can view the translated content in each langauge.",
    "ORIGINAL_CONTENT": "Original Content",
    "TRANSLATED_CONTENT": "Translated Content",
    "NO_TRANSLATIONS_AVAILABLE": "No translations are available for this content"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing",
    "IMAGE_ALT": "Qualcuno sta scrivendo"
  },
  "READING": {
    "ONE": "{user} sta leggendo questo ticket",
    "TWO": "{user} e {secondUser} stanno leggendo questo ticket",
    "MULTIPLE": "{user} e altri {count} stanno leggendo questo ticket"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Sposta conversazione",
    "DESCRIPTION": "Sposta questa conversazione in una casella email diversa.",
    "SOURCE": {
      "TITLE": "Conversazione",
      "ID_LABEL": "ID conversazione"
    },
    "TARGET": {
      "TITLE": "Casella di destinazione",
      "PLACEHOLDER": "Seleziona una casella email",
      "NO_RESULTS": "Nessun'altra casella email disponibile",
      "ERROR": "Seleziona una casella di destinazione"
    },
    "SUBMIT": "Sposta conversazione",
    "CANCEL": "Annulla",
    "SUCCESS_MESSAGE": "Conversazione spostata con successo",
    "ERROR_MESSAGE": "Impossibile spostare la conversazione. Riprova."
  },
  "MERGE": {
    "TITLE": "Unisci conversazioni",
    "DESCRIPTION": "Unisci questa conversazione con un'altra conversazione. Tutti i messaggi di questa conversazione saranno spostati nella conversazione di destinazione e questa conversazione sarà eliminata.",
    "SOURCE": {
      "TITLE": "Conversazione di origine (sarà eliminata)",
      "ID_LABEL": "ID conversazione"
    },
    "TARGET": {
      "TITLE": "Conversazione di destinazione",
      "PLACEHOLDER": "Digita l'ID della conversazione per cercare (es. 123)",
      "HELP": "Inserisci l'ID della conversazione in cui unire tutti i messaggi.",
      "ERROR": "Seleziona una conversazione di destinazione"
    },
    "WARNING": "Attenzione: questa azione non può essere annullata. Tutti i messaggi saranno spostati nella conversazione di destinazione e questa conversazione sarà eliminata definitivamente.",
    "SUBMIT": "Unisci conversazioni",
    "CANCEL": "Annulla",
    "SUCCESS_MESSAGE": "Conversazione unita con successo",
    "ERROR_MESSAGE": "Impossibile unire le conversazioni. Controlla la conversazione di destinazione e riprova.",
    "SEARCH": {
      "NO_RESULTS": "Nessuna conversazione trovata con questo ID",
      "ERROR_MESSAGE": "Impossibile cercare le conversazioni. Riprova."
    },
    "CONFIRM": {
      "TITLE": "Conferma unione",
      "DESCRIPTION": "Sei sicuro di voler unire questa conversazione? Questa azione non può essere annullata.",
      "YES": "Sì, unisci",
      "CANCEL": "Annulla"
    }
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  }
}
